const defaultSettings = {
    "formWidth": 600,
    "formGap": 8,
    "tabName": "info",
    "gridWidth": 200,
    "lang": "en",
    "defaultCurrency": "bgn",
    "requiredLanguages": [
        "en",
        "bg"
    ],
    "mainLanguages": [ "en" ],
    "otherLanguages": [ "bg" ],
    "minItemsToSearchInFilter": 10,
    "articleCodeSeparator": "-",
    "secondMenuCollapsible": true,
    "mainMenuTheme": "dark",
    "secondMenuTheme": "dark",
    "loginType": "password",
    "languages": [
        "en",
        "bg"
    ],
    "currency": [
        "eur",
        "bgn"
    ]
}

export default defaultSettings;